import React from 'react';

export const BlankStateNotes = (props) => (
  <svg
    fill="none"
    height="150"
    viewBox="0 0 191 150"
    width="191"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.2">
      <path d="M183 31.1721H8V126H183V31.1721Z" fill="#575A89" />
      <path
        d="M90.7165 37.4268H15.7734V120.552H90.7165V37.4268Z"
        fill="white"
      />
      <path
        d="M100.284 120.552L175.227 120.552V37.4268L100.284 37.4268L100.284 120.552Z"
        fill="white"
      />
      <path
        d="M81.1493 47.9182H21.7529V49.9358H81.1493V47.9182Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M81.1493 55.9888H21.7529V58.0064H81.1493V55.9888Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M81.1493 64.0593H21.7529V66.0769H81.1493V64.0593Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M165.859 47.9182H106.462V49.9358H165.859V47.9182Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M165.859 55.9888H106.462V58.0064H165.859V55.9888Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M165.859 64.0593H106.462V66.0769H165.859V64.0593Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M81.1493 72.1296H21.7529V74.1473H81.1493V72.1296Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M81.1493 80.2002H21.7529V82.2178H81.1493V80.2002Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M81.1493 88.2705H21.7529V90.2881H81.1493V88.2705Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M81.1493 96.3411H21.7529V98.3587H81.1493V96.3411Z"
        fill="#6C63FF"
        opacity="0.2"
      />
      <path
        d="M81.1493 104.411H21.7529V106.429H81.1493V104.411Z"
        fill="#6C63FF"
        opacity="0.2"
      />
    </g>
  </svg>
);
